// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Game Components CSS Module
 * PERFORMANCE OPTIMIZED: Consolidates multiple small styled-components
 * into a single CSS module for better performance
 */
/* ButtonFavorites */
.Ee3gPFQm5hntWPz0jmCM {
  position: absolute;
  cursor: pointer;
  z-index: 10;
  /* Touch optimizations */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  /* Mobile-first sizing and positioning */
  top: 5px;
  right: 5px;
  width: 21px;
  height: 21px;
  /* Prevent flickering on iOS */
  backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
}
/* bigger clickable area of the btn */
.Ee3gPFQm5hntWPz0jmCM::after {
  content: '';
  position: absolute;
  inset-block: -7px;
  inset-inline: -7px;
}
@media (min-width: 1025px) {
  .Ee3gPFQm5hntWPz0jmCM {
    width: 32px;
    height: 32px;
  }
}
.Ee3gPFQm5hntWPz0jmCM svg {
  width: 21px;
  height: 21px;
  float: right;
}
@media (min-width: 1025px) {
  .Ee3gPFQm5hntWPz0jmCM svg {
    width: 28px;
    height: 28px;
  }
}
/* TagsContainer */
.zZKbsaSaitqKGAW5sXLB {
  position: absolute;
  display: flex;
  max-height: 25%;
  pointer-events: none;
}
.zZKbsaSaitqKGAW5sXLB.OURp2v_wBNjcwGRWJf4Y {
  top: 0px;
  left: 0px;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
.zZKbsaSaitqKGAW5sXLB.OURp2v_wBNjcwGRWJf4Y picture {
  width: var(--badge-normal-picture-width, 50%);
}
.zZKbsaSaitqKGAW5sXLB.OURp2v_wBNjcwGRWJf4Y picture img {
  width: var(--badge-normal-img-width, 80%);
  min-height: 1px;
  /* prevents image not being displayed on some devices */
}
/* Uncomment this if they say the badges are too big and don’t fit in the banner 
.tagsContainer.normalJackpot[data-branding='christmas'] {
  width: 80%;
} */
.zZKbsaSaitqKGAW5sXLB.xYgwkUZtYfucZ2z8BLaW {
  top: var(--badge-spj-top, 1px);
  left: var(--badge-spj-left, 20%);
  transform: translateX(-50%);
  justify-content: center;
  width: var(--badge-spj-width, 36%);
  height: auto;
}
@media (min-width: 769px) {
  .zZKbsaSaitqKGAW5sXLB.xYgwkUZtYfucZ2z8BLaW {
    top: 0;
    width: var(--badge-spj-width, 40%);
  }
}
/* MinMaxBet */
.RckYVMOiLbyP6mWNQmgA {
  color: var(--game-min-max-bet-color, #fbdf19);
  font-weight: bold;
  line-height: 1.2;
  display: flex;
  align-items: center;
  gap: 2px;
}
.GK8mDAr3MOcMb2j7AkuC {
  /* Mobile-first responsive sizing - force specific dimensions */
  width: 10px !important;
  height: 10px !important;
  min-width: 10px !important;
  min-height: 10px !important;
  max-width: 10px !important;
  max-height: 10px !important;
  margin-right: 2px;
  margin-bottom: 1px;
  flex-shrink: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
@media (min-width: 1026px) {
  .GK8mDAr3MOcMb2j7AkuC {
    width: 17px !important;
    height: 17px !important;
    min-width: 17px !important;
    min-height: 17px !important;
    max-width: 17px !important;
    max-height: 17px !important;
    margin-right: 3px;
    margin-bottom: 3px;
  }
}
.fffLrfC46dlVylE1JLz1 {
  font-family: var(--font-family-quaternary);
  font-size: var(--game-info-bar-font-size, 12px);
  color: var(--game-min-max-bet-color, #fbdf19);
}
@media (min-width: 1026px) {
  .fffLrfC46dlVylE1JLz1 {
    font-size: 19px;
  }
}
.GS6E4BerWrZsrWhzYIDP {
  font-family: var(--font-family-quaternary, 'San Francisco Bold');
  color: var(--game-min-max-bet-color, #fbdf19);
  font-size: var(--game-info-bar-font-size, 12px);
  font-weight: 700;
  align-self: baseline;
}
@media (orientation: landscape) and (max-height: 430px) {
  .fffLrfC46dlVylE1JLz1[data-view='multi'],
  .GS6E4BerWrZsrWhzYIDP[data-view='multi'] {
    font-size: 16px;
  }
  .GK8mDAr3MOcMb2j7AkuC[data-view='single'] {
    margin-bottom: 0px;
  }
  .GK8mDAr3MOcMb2j7AkuC {
    width: 12px;
    height: 12px;
    min-width: 12px;
    min-height: 12px;
    max-width: 12px;
    max-height: 12px;
  }
}
.z4SoFVuQjOMWTOFLj8Qo {
  margin-left: 0.8px;
  color: var(--game-min-max-bet-color, #fbdf19);
  font-size: 10px;
  font-weight: 700;
  font-family: var(--font-family-quaternary);
  letter-spacing: 0.8px;
  align-self: baseline;
}
@media (orientation: landscape) and (max-height: 430px) {
  .z4SoFVuQjOMWTOFLj8Qo {
    font-size: 12px;
  }
}
@media (min-width: 1026px) {
  .GS6E4BerWrZsrWhzYIDP {
    font-size: 19px;
  }
  .z4SoFVuQjOMWTOFLj8Qo {
    font-size: 17px;
  }
}
/* CurrentPlayersCount */
.Zm6DSxAWwvz9w7o3uID2 {
  display: flex;
  align-items: center;
  color: #fff;
  font-weight: bold;
  line-height: 1.2;
}
.Zm6DSxAWwvz9w7o3uID2 picture {
  display: flex;
}
/* Image sizing handled in Game.module.css to override global .gameCard img rule */
.yaGMuGBOknlXFnPpxDoZ {
  margin-left: 3px;
  font-family: var(--font-family-quaternary);
  font-size: var(--game-info-bar-font-size, 12px);
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
}
@media (min-width: 1026px) {
  .yaGMuGBOknlXFnPpxDoZ {
    font-size: 19px;
  }
}
.vpSLGibkmRMwlbj0BFeY {
  position: absolute;
  width: 20%;
  top: 26.5%;
  left: 2%;
  cursor: default;
}
.vpSLGibkmRMwlbj0BFeY svg {
  width: 20px;
  height: 20px;
}
/* Tournament cup appear animation */
.qIqso2KTXw7Xl9JSd133 {
  animation: Vp48alw3Dx_Eg0RDsrEN 0.6s ease-out forwards;
}
/* Respect reduced motion preference for accessibility */
@media (prefers-reduced-motion: reduce) {
  .qIqso2KTXw7Xl9JSd133 {
    animation: nnoHpoLzc3XSwuMcAjX0 0.2s ease-out forwards;
  }
}
@keyframes Vp48alw3Dx_Eg0RDsrEN {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes nnoHpoLzc3XSwuMcAjX0 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@media (min-height: 500px) {
  [data-view='single'][data-section='pickRandom'] .Ee3gPFQm5hntWPz0jmCM {
    width: 32px;
    height: 32px;
  }
  [data-view='single'][data-section='pickRandom'] .Ee3gPFQm5hntWPz0jmCM svg {
    width: 28px;
    height: 28px;
  }
  [data-view='single'][data-section='pickRandom'] .GK8mDAr3MOcMb2j7AkuC {
    width: 14px !important;
    height: 14px !important;
    min-width: 14px !important;
    min-height: 14px !important;
    max-width: 14px !important;
    max-height: 14px !important;
  }
  [data-view='single'][data-section='pickRandom'] .fffLrfC46dlVylE1JLz1,
  [data-view='single'][data-section='pickRandom'] .GS6E4BerWrZsrWhzYIDP,
  [data-view='single'][data-section='pickRandom'] .yaGMuGBOknlXFnPpxDoZ {
    font-size: 19px;
  }
  [data-view='single'][data-section='pickRandom'] .z4SoFVuQjOMWTOFLj8Qo {
    font-size: 17px;
  }
}
@media (min-width: 1025px) {
  [data-game-card-size="compact"] .Ee3gPFQm5hntWPz0jmCM {
    width: 21px;
    height: 21px;
  }
  [data-game-card-size="compact"] .Ee3gPFQm5hntWPz0jmCM svg {
    width: 21px;
    height: 21px;
  }
  [data-game-card-size="compact"] .GK8mDAr3MOcMb2j7AkuC {
    width: 10px !important;
    height: 10px !important;
    min-width: 10px !important;
    min-height: 10px !important;
    max-width: 10px !important;
    max-height: 10px !important;
    margin-right: 2px;
    margin-bottom: 1px;
  }
  [data-game-card-size="compact"] .fffLrfC46dlVylE1JLz1,
  [data-game-card-size="compact"] .GS6E4BerWrZsrWhzYIDP,
  [data-game-card-size="compact"] .yaGMuGBOknlXFnPpxDoZ {
    font-size: 12px;
  }
  [data-game-card-size="compact"] .z4SoFVuQjOMWTOFLj8Qo {
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/GameCard/components/GameComponents/GameComponents.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF,oBAAoB;AACpB;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,wCAAwC;EACxC,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;EACxC,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;EACxB,mCAAmC;EACnC,gCAAgC;AAClC;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,yCAAyC;EACzC,eAAe;EACf,uDAAuD;AACzD;AACA;;;GAGG;AACH;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,uBAAuB;EACvB,kCAAkC;EAClC,YAAY;AACd;AACA;EACE;IACE,MAAM;IACN,kCAAkC;EACpC;AACF;AACA,cAAc;AACd;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,+DAA+D;EAC/D,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE,0CAA0C;EAC1C,+CAA+C;EAC/C,6CAA6C;AAC/C;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gEAAgE;EAChE,6CAA6C;EAC7C,+CAA+C;EAC/C,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA,kFAAkF;AAClF;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,+CAA+C;EAC/C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA,oCAAoC;AACpC;EACE,sDAAqD;AACvD;AACA,wDAAwD;AACxD;EACE;IACE,sDAA4D;EAC9D;AACF;AACA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;EACpB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/**\n * Game Components CSS Module\n * PERFORMANCE OPTIMIZED: Consolidates multiple small styled-components\n * into a single CSS module for better performance\n */\n/* ButtonFavorites */\n.favoriteButton {\n  position: absolute;\n  cursor: pointer;\n  z-index: 10;\n  /* Touch optimizations */\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n  /* Mobile-first sizing and positioning */\n  top: 5px;\n  right: 5px;\n  width: 21px;\n  height: 21px;\n  /* Prevent flickering on iOS */\n  backface-visibility: hidden;\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  -webkit-transform: translateZ(0);\n}\n/* bigger clickable area of the btn */\n.favoriteButton::after {\n  content: '';\n  position: absolute;\n  inset-block: -7px;\n  inset-inline: -7px;\n}\n@media (min-width: 1025px) {\n  .favoriteButton {\n    width: 32px;\n    height: 32px;\n  }\n}\n.favoriteButton svg {\n  width: 21px;\n  height: 21px;\n  float: right;\n}\n@media (min-width: 1025px) {\n  .favoriteButton svg {\n    width: 28px;\n    height: 28px;\n  }\n}\n/* TagsContainer */\n.tagsContainer {\n  position: absolute;\n  display: flex;\n  max-height: 25%;\n  pointer-events: none;\n}\n.tagsContainer.normalJackpot {\n  top: 0px;\n  left: 0px;\n  justify-content: flex-start;\n  width: 100%;\n  height: auto;\n}\n.tagsContainer.normalJackpot picture {\n  width: var(--badge-normal-picture-width, 50%);\n}\n.tagsContainer.normalJackpot picture img {\n  width: var(--badge-normal-img-width, 80%);\n  min-height: 1px;\n  /* prevents image not being displayed on some devices */\n}\n/* Uncomment this if they say the badges are too big and don’t fit in the banner \n.tagsContainer.normalJackpot[data-branding='christmas'] {\n  width: 80%;\n} */\n.tagsContainer.spjJackpot {\n  top: var(--badge-spj-top, 1px);\n  left: var(--badge-spj-left, 20%);\n  transform: translateX(-50%);\n  justify-content: center;\n  width: var(--badge-spj-width, 36%);\n  height: auto;\n}\n@media (min-width: 769px) {\n  .tagsContainer.spjJackpot {\n    top: 0;\n    width: var(--badge-spj-width, 40%);\n  }\n}\n/* MinMaxBet */\n.minMaxContainer {\n  color: var(--game-min-max-bet-color, #fbdf19);\n  font-weight: bold;\n  line-height: 1.2;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n.betIcon {\n  /* Mobile-first responsive sizing - force specific dimensions */\n  width: 10px !important;\n  height: 10px !important;\n  min-width: 10px !important;\n  min-height: 10px !important;\n  max-width: 10px !important;\n  max-height: 10px !important;\n  margin-right: 2px;\n  margin-bottom: 1px;\n  flex-shrink: 0;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n@media (min-width: 1026px) {\n  .betIcon {\n    width: 17px !important;\n    height: 17px !important;\n    min-width: 17px !important;\n    min-height: 17px !important;\n    max-width: 17px !important;\n    max-height: 17px !important;\n    margin-right: 3px;\n    margin-bottom: 3px;\n  }\n}\n.betText {\n  font-family: var(--font-family-quaternary);\n  font-size: var(--game-info-bar-font-size, 12px);\n  color: var(--game-min-max-bet-color, #fbdf19);\n}\n@media (min-width: 1026px) {\n  .betText {\n    font-size: 19px;\n  }\n}\n.maxBetText {\n  font-family: var(--font-family-quaternary, 'San Francisco Bold');\n  color: var(--game-min-max-bet-color, #fbdf19);\n  font-size: var(--game-info-bar-font-size, 12px);\n  font-weight: 700;\n  align-self: baseline;\n}\n@media (orientation: landscape) and (max-height: 430px) {\n  .betText[data-view='multi'],\n  .maxBetText[data-view='multi'] {\n    font-size: 16px;\n  }\n  .betIcon[data-view='single'] {\n    margin-bottom: 0px;\n  }\n  .betIcon {\n    width: 12px;\n    height: 12px;\n    min-width: 12px;\n    min-height: 12px;\n    max-width: 12px;\n    max-height: 12px;\n  }\n}\n.maxBetTextSPJ {\n  margin-left: 0.8px;\n  color: var(--game-min-max-bet-color, #fbdf19);\n  font-size: 10px;\n  font-weight: 700;\n  font-family: var(--font-family-quaternary);\n  letter-spacing: 0.8px;\n  align-self: baseline;\n}\n@media (orientation: landscape) and (max-height: 430px) {\n  .maxBetTextSPJ {\n    font-size: 12px;\n  }\n}\n@media (min-width: 1026px) {\n  .maxBetText {\n    font-size: 19px;\n  }\n  .maxBetTextSPJ {\n    font-size: 17px;\n  }\n}\n/* CurrentPlayersCount */\n.playersContainer {\n  display: flex;\n  align-items: center;\n  color: #fff;\n  font-weight: bold;\n  line-height: 1.2;\n}\n.playersContainer picture {\n  display: flex;\n}\n/* Image sizing handled in Game.module.css to override global .gameCard img rule */\n.playersText {\n  margin-left: 3px;\n  font-family: var(--font-family-quaternary);\n  font-size: var(--game-info-bar-font-size, 12px);\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.2;\n}\n@media (min-width: 1026px) {\n  .playersText {\n    font-size: 19px;\n  }\n}\n.cupContainer {\n  position: absolute;\n  width: 20%;\n  top: 26.5%;\n  left: 2%;\n  cursor: default;\n}\n.cupContainer svg {\n  width: 20px;\n  height: 20px;\n}\n/* Tournament cup appear animation */\n.cupAppear {\n  animation: tournamentCupFadeIn 0.6s ease-out forwards;\n}\n/* Respect reduced motion preference for accessibility */\n@media (prefers-reduced-motion: reduce) {\n  .cupAppear {\n    animation: tournamentCupFadeInReduced 0.2s ease-out forwards;\n  }\n}\n@keyframes tournamentCupFadeIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(1.05);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes tournamentCupFadeInReduced {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@media (min-height: 500px) {\n  [data-view='single'][data-section='pickRandom'] .favoriteButton {\n    width: 32px;\n    height: 32px;\n  }\n  [data-view='single'][data-section='pickRandom'] .favoriteButton svg {\n    width: 28px;\n    height: 28px;\n  }\n  [data-view='single'][data-section='pickRandom'] .betIcon {\n    width: 14px !important;\n    height: 14px !important;\n    min-width: 14px !important;\n    min-height: 14px !important;\n    max-width: 14px !important;\n    max-height: 14px !important;\n  }\n  [data-view='single'][data-section='pickRandom'] .betText,\n  [data-view='single'][data-section='pickRandom'] .maxBetText,\n  [data-view='single'][data-section='pickRandom'] .playersText {\n    font-size: 19px;\n  }\n  [data-view='single'][data-section='pickRandom'] .maxBetTextSPJ {\n    font-size: 17px;\n  }\n}\n@media (min-width: 1025px) {\n  [data-game-card-size=\"compact\"] .favoriteButton {\n    width: 21px;\n    height: 21px;\n  }\n  [data-game-card-size=\"compact\"] .favoriteButton svg {\n    width: 21px;\n    height: 21px;\n  }\n  [data-game-card-size=\"compact\"] .betIcon {\n    width: 10px !important;\n    height: 10px !important;\n    min-width: 10px !important;\n    min-height: 10px !important;\n    max-width: 10px !important;\n    max-height: 10px !important;\n    margin-right: 2px;\n    margin-bottom: 1px;\n  }\n  [data-game-card-size=\"compact\"] .betText,\n  [data-game-card-size=\"compact\"] .maxBetText,\n  [data-game-card-size=\"compact\"] .playersText {\n    font-size: 12px;\n  }\n  [data-game-card-size=\"compact\"] .maxBetTextSPJ {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"favoriteButton": `Ee3gPFQm5hntWPz0jmCM`,
	"tagsContainer": `zZKbsaSaitqKGAW5sXLB`,
	"normalJackpot": `OURp2v_wBNjcwGRWJf4Y`,
	"spjJackpot": `xYgwkUZtYfucZ2z8BLaW`,
	"minMaxContainer": `RckYVMOiLbyP6mWNQmgA`,
	"betIcon": `GK8mDAr3MOcMb2j7AkuC`,
	"betText": `fffLrfC46dlVylE1JLz1`,
	"maxBetText": `GS6E4BerWrZsrWhzYIDP`,
	"maxBetTextSPJ": `z4SoFVuQjOMWTOFLj8Qo`,
	"playersContainer": `Zm6DSxAWwvz9w7o3uID2`,
	"playersText": `yaGMuGBOknlXFnPpxDoZ`,
	"cupContainer": `vpSLGibkmRMwlbj0BFeY`,
	"cupAppear": `qIqso2KTXw7Xl9JSd133`,
	"tournamentCupFadeIn": `Vp48alw3Dx_Eg0RDsrEN`,
	"tournamentCupFadeInReduced": `nnoHpoLzc3XSwuMcAjX0`
};
export default ___CSS_LOADER_EXPORT___;
